import styled from "styled-components";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

export const MainNavCanvasDefaultBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 23rem;
  flex: 1;
  background: ${props => props.theme.colors.backgroundMiddleDark};
  box-shadow: 1rem 0 3rem ${props => props.theme.colors.backgroundDark};
  transition: transform 0.2s ease-in-out;
  overflow: hidden;
  padding-bottom: env(safe-area-inset-bottom, 0);

  ${CssRule.For.RTL.build()} & {
    box-shadow: -1rem 0 3rem ${props => props.theme.colors.backgroundLight};
  }

  @media ${({theme}) => theme.mediaQuery.lAndBelow} {
    ${CssRule.For.RTL.build()} & {
      transform: translateX(0);
    }
  }
  
  @media ${({theme}) => theme.mediaQuery.mAndBelow} {
    width: 37.5rem;
  }

  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
    width: 100vw;
    box-shadow: none;
  }
`